import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import * as FlatActions from '@medsurf/flat-actions';
import * as FlatStates from '@medsurf/flat-states';

@Injectable()
export class PageSharedFacade {
  constructor(protected store: Store) {
  }

  //<editor-fold desc="Selectors">

  currentSelectedInfoPage$ = this.store.select(FlatStates.PageEntityState.currentSelectedInfoPage$);

  //</editor-fold>

  //<editor-fold desc="Requests">

  requestPageByCurrentRoute() {
    return this.store.dispatch(new FlatActions.PageControlActions.GetPageByCurrentRoute());
  }

  //</editor-fold>

}
